<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand" to="/" @click.native="goToHome">
                <div style="height: 40px;">
                    <img style="height: 100%;" alt="Logo LotePerfecto" :src="['search', 'publish', 'map-search'].includes($route.name) ? require('../assets/logo-white-200.webp') : require('../assets/logo-200.webp')">
                </div>
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/" @click="goToHome">
                        <img alt="Logo LotePerfecto" src="../assets/logo-200.webp">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeCollapsableMenu(closeMenu)"></close-button>
                </div>
            </div>
            <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto" slot-scope="{closeMenu}">
                <router-link @click.native="clickHeaderLink(closeMenu, 'Search')" class="nav-link" :class="`${['publish', 'search', 'map-search'].includes($route.name) ? 'text-white' : 'text-dark'} ${$route.name === 'search' || $route.name === 'map-search' ? 'bold' : ''}`" :to="splitSearch">Quiero alquilar</router-link>
                <router-link @click.native="clickHeaderLink(closeMenu, 'Publish')" class="nav-link" :class="`${['publish', 'search', 'map-search'].includes($route.name) ? 'text-white' : 'text-dark'} ${$route.name === 'publish' ? 'bold' : ''}`" to="/offer">Quiero publicar</router-link>
                <router-link @click.native="clickHeaderLink(closeMenu, 'About us')" class="nav-link" :class="`${['publish', 'search', 'map-search'].includes($route.name) ? 'text-white' : 'text-dark'} ${$route.name === 'aboutUs' ? 'bold' : ''}`" to="/about-us">Nosotros</router-link>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import mixpanel from "mixpanel-browser";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  methods: {
    clickHeaderLink (closeMenu, section) {
        closeMenu()
        mixpanel.track('Click change section link', {
          section
        })
    },
    goToHome () {
        mixpanel.track('Click home logo')
    },
    closeCollapsableMenu (closeMenu) {
        closeMenu()
        mixpanel.track('Close collapsable menu')
    }
  },
  computed: {
    splitSearch() {
        const treatment = this.$splitClient.getTreatment('ab_testing_map_search_loteperfecto');
        if (treatment === 'on') {
          return '/map-search'
        } else {
          return '/search'
        }
    }
  }
};
</script>
<style scoped>
.bold {
    font-weight: bold !important;
}
</style>
